import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class TKCompareWrapper extends TKCustomElementFactory {
    isMobile: boolean;
    isMobileActive: boolean;
    desktopMinWidth: number;
    compareCategoryDefaultWrapper: HTMLDivElement | undefined;
    compareCategoryWrapper: HTMLDivElement | undefined;
    compareCategorySelect: HTMLDivElement | undefined;
    compareRowContainer: HTMLDivElement |undefined;
    compareItemsCount: number;

    constructor() {
        super();

        this.desktopMinWidth = Number(this.getAttribute('data-tk-desktop-min-width')) || 1200;
        this.isMobile = window.viewport.clientWidth < this.desktopMinWidth;
        this.isMobileActive = false;
        this.compareCategoryDefaultWrapper = this.querySelector<HTMLDivElement>('[data-tk-category-default-wrapper]')
            || undefined;
        this.compareCategoryWrapper = this.querySelector<HTMLDivElement>('[data-tk-category-wrapper]')
            || undefined;
        this.compareCategorySelect = this.querySelector<HTMLDivElement>('[data-tk-categories]')
            || undefined;
        this.compareRowContainer = this.querySelector<HTMLDivElement>('[data-tk-row-container]')
            || undefined;
        this.compareItemsCount = Number(this.getAttribute('data-compare-items-count')) || 0;
    }

    connectedCallback(): void {
        this.registerViewportListener();

        this.isMobile && this.switchToMobile();

        this.observeItemsCount();
    }

    registerViewportListener(): void {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({ event: 'tk-viewport-resize', element: window.viewport, action: onViewportResize });
    }

    handleViewportResize(event: Event): void {
        const customEvent = event as CustomEvent;
        this.isMobile = customEvent.detail.width < this.desktopMinWidth;
        this.isMobile ? this.switchToMobile() : this.switchToDesktop();
    }

    switchToMobile() {
        if (this.isMobileActive || (this.compareItemsCount <= 0)) return;
        this.isMobileActive = true;

        // place category select in category compare wrapper
        if (!this.compareCategoryWrapper) throw new Error('Missing compare category wrapper element');
        if (!this.compareCategorySelect) throw new Error('Missing compare category select element');

        this.compareCategorySelect.parentElement?.removeChild(this.compareCategorySelect);
        this.compareCategoryWrapper.appendChild(this.compareCategorySelect);

        // hide first column
        if (!this.compareRowContainer) throw new Error('Missing rows container');
        const rows = this.compareRowContainer.querySelectorAll('[data-tk-row]');
        rows.forEach((row) => {
            const firstDiv = row.querySelector<HTMLDivElement>('div:first-of-type');

            if (firstDiv) {
                firstDiv.setAttribute('hidden', '');
            }
        });
    }

    switchToDesktop() {
        if (!this.isMobileActive || (this.compareItemsCount <= 0)) return;
        this.isMobileActive = false;

        // place category select in category compare default wrapper
        if (!this.compareCategoryDefaultWrapper) throw new Error('Missing compare category default wrapper element');
        if (!this.compareCategorySelect) throw new Error('Missing compare category select element');

        this.compareCategorySelect.parentElement?.removeChild(this.compareCategorySelect);
        this.compareCategoryDefaultWrapper.appendChild(this.compareCategorySelect);

        // show first column
        if (!this.compareRowContainer) throw new Error('Missing rows container');
        const rows = this.compareRowContainer.querySelectorAll('[data-tk-row]');
        rows.forEach((row) => {
            const firstDiv = row.querySelector<HTMLDivElement>('div:first-of-type');

            if (firstDiv) {
                firstDiv.removeAttribute('hidden');
            }
        });
    }

    observeItemsCount() {
        const observerOption = { childList: true, subtree: true };
        const removeRow = document.querySelector<HTMLDivElement>('[data-tk-id="Remove"]');

        if (!removeRow) return;

        const onItemsCountChanged = this.calculateItemsCount.bind(this);
        const observer = new MutationObserver(onItemsCountChanged);

        observer.observe(removeRow, observerOption);
    }

    calculateItemsCount() {
        const removeRow = document.querySelector<HTMLDivElement>('[data-tk-id="Remove"]');

        const itemsCount = removeRow ? removeRow.querySelectorAll('tk-compare-button').length : 0;

        this.setAttribute('data-compare-items-count', itemsCount.toString());
    }
}
